<template>
  <div class="NewsDetails">
   <!-- <banner img="../assets/img/bgtop.jpg" title="服务网络" />-->
    <div class="NewsDetails-product">
      <div class="NewsDetails-product-content">
       <!-- <img src="../assets/img2020/service_network.jpg" alt />-->
          <p class="product-content">目前我公司已形成完善的服务网络，覆盖全球超过90%的国家和地区，能够为各行各业的进出口企业提供全方位高覆盖的货物运输服务。</p>
        <img  style="margin-top:70px;" v-lazy="require('@/assets/businessScope/service_network.jpg')" alt />
        <p class="product-title">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
        <p class="product-time">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>

      </div>
    </div>
  </div>
</template>
<script>
    import Banner from "../components/Banner";
    export default {
        name: "NewsDetails",
        components: {
            Banner
        },
        data() {
            return {
                pid:'',
                newsIdList: {},
            };
        },
        created() {
            this.pid = this.$route.params.id;
            window.console.log(this.pid);
        },
        mounted() {
            this.loadData();
        },
        methods: {
            loadData() {
                let that = this;
                this.$http
                    .get(`/News/`)
                    .then(response => {
                        //console.log(response);
                        debugger
                        for (let i = 0; i < response.data.length; i++) {
                            if(response.data[i].Id==that.pid){
                                that.newsIdList = response.data[i];
                                //that.newsIdList
                            }
                        }
                        //window.console.log(this.newsIdList);
                    })
                    .catch(function(error) {
                        window.console.log(error);
                    });
            }
        }
    };
</script>

<style lang="scss" scoped>
  .NewsDetails {
    width: 100%;
    height: 100%;
    //overflow: hidden;
    background-color: #14679f;
    &-product {
      width: 1240px;
      margin: 0 auto;
      background-color: #fff;
      border: 1px solid red;
        padding-top:50px;
      &-content {
        width: 760px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 50px 0;
        img {
          width: 100%;
          //height: 500px;
        }
        .product-title {
          font-size: 25px;
          color: #e13834;
          padding: 20px 0;
        }
        .product-content {
          font-size: 17px;
          font-weight: bolder;
         //padding: 20px 0;
           // margin-top:30px;
        }
      }
    }
  }
</style>
